import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  fr: {
    translation: {
      // Auth & Welcome
      welcome: {
        title: "Bienvenue sur Trakna",
        subtitle: "Rencontrez des personnes qui partagent vos centres d'intérêt",
        logoAlt: "Logo Trakna",
        continueWithGoogle: "Continuer avec Google",
        continueWithFacebook: "Continuer avec Facebook",
        continueWithPhone: "Continuer avec téléphone",
        googleAlt: "Logo Google",
        facebookAlt: "Logo Facebook",
        termsText: "En vous connectant, vous acceptez nos",
        termsLink: "Conditions d'utilisation",
        and: "et notre",
        privacyLink: "Politique de confidentialité",
        errors: {
          default: "Une erreur s'est produite lors de la connexion",
          popupClosed: "La fenêtre de connexion a été fermée",
          requestCancelled: "La demande de connexion a été annulée",
          accountExists: "Un compte existe déjà avec une autre méthode de connexion",
          network: "Erreur de connexion réseau. Veuillez vérifier votre connexion internet",

        },
        login: {
          google: "Continuer avec Google",
          facebook: "Continuer avec Facebook"
        },
        legal: {
          agreement: "En continuant, vous acceptez nos",
          terms: "Conditions d'utilisation",
          and: "et notre",
          privacy: "Politique de confidentialité"
        }
      },

      // Invitations
      invitations: {
        title: "Acheter des invitations",
        subtitle: "Envoyez des invitations à sortirs et laissez-vous inspirer !",
        credits: "invitations",
        price: "{{price}} FCFA",
        purchase: "Acheter des invitations"
      },

      paymentPhone: {
        title: "Numéro de paiement",
        description: "Ce numéro sera utilisé pour ouvrir la page de paiement.",
        invalid: "Numéro de téléphone invalide. Vérifiez le numéro et l'indicatif pays.",
        cancel: "Annuler",
        continue: "Continuer",
        processing: "Ouverture..."
      },

      // Subscription
      subscription: {
        mySubscription: "Mon Abonnement",
        startingFrom: "À partir de",
        plans: {
          plus: {
            title: "Trakna Plus",
            name: "PLUS",
            description: "Swipez sans limites!",
            features: {
              unlimitedLikes: "Likes illimités",
              seeWhoLikesYou: "Voir qui vous aime",
              priorityLikes: "Likes prioritaires",
              unlimitedRewinds: "Rewinds illimités",
              freeInvitations: "Invitations gratuites par semaine",
              acceptInvitations: "Accepter des invitations en illimitées",
              messageBeforeMatch: "Message avant le match",
              passport: "Passport",
              topPicks: "Profil boostés"
            }
          },
          gold: {
            title: "Trakna Gold",
            name: "GOLD",
            description: "Decouvre qui a liké ton profil pour matcher instantanément!",
            features: {
              unlimitedLikes: "Likes illimités",
              seeWhoLikesYou: "Voir qui vous aime",
              priorityLikes: "Likes prioritaires",
              unlimitedRewinds: "Rewinds illimités",
              freeInvitations: "2 Invitations gratuites par semaine",
              acceptInvitations: "Accepter des invitations en illimitées",
              messageBeforeMatch: "Message avant le match",
              passport: "Passport",
              topPicks: "Profil boostés"
            }
          },
          platinum: {
            title: "Trakna Platinum",
            name: "PLATINUM",
            description: "Profitez de toutes nos fonctionnalités premium !",
            features: {
              unlimitedLikes: "Likes illimités",
              seeWhoLikesYou: "Voir qui vous aime",
              priorityLikes: "Likes prioritaires",
              unlimitedRewinds: "Rewinds illimités",
              freeInvitations: "5 Invitations gratuites par semaine",
              acceptInvitations: "Accepter des invitations en illimitées",
              messageBeforeMatch: "Message avant le match",
              passport: "Passport",
              topPicks: "Profil boostés"
            }
          }
        },
        duration: {
          oneMonth: "1 mois",
          threeMonths: "3 mois",
          sixMonths: "6 mois"
        },
        continue: "Continuer",
        perMonth: "par mois",
        discount: "- {{percent}}%",
        upgradeMessages: {
          swipeLimit: "Limite de swipes journalière atteinte ! Passez à la version premium pour continuer !",
          message: "Passez à la version premium pour envoyer un message !",
          goBack: "Impossible de revenir en arrière ! Passez à la version premium pour revoir le profil précédent !",
          invitations: "Passez en premium pour accepter des invitations en illimitées !",
        },
        features: {
          unlimitedLikes: "Likes illimités",
          seeWhoLikedYou: "Découvre qui a liké ton profil",
          unlimitedRewinds: "Rewinds illimités",
          freeBoostMonthly: "1 Boost gratuit par mois",
          freeSuperlikes: "2 Superlikes gratuits par semaine",
          passportMode: "Mode Passeport en illimité",
          description: "Matche et discute avec des gens dans le monde entier.",
          topPicks: "Coups de cœur",
          description2: "Découvre chaque jour une sélection de profils.",
          profileControl: "Contrôle ton profil de A à Z",
          description3: "Dévoile seulement ce que tu veux montrer."
        }
      },
      location: {
        title: "Activez votre GPS",
        subtitle: "Pour vous proposer les meilleurs profils près de chez vous",
        locating: "Localisation en cours...",
        info: "Votre position est nécessaire pour trouver des profils près de chez vous",

        options: {
          useGPS: "Activer le GPS maintenant",
          useGPSDescription: "Recommandé - Précision ±50m",
          useIPTemporary: "Continuer avec position approximative",
          useIPDescription: "Temporaire - Vous devrez activer le GPS plus tard",
          recommended: "Recommandé",
          retrying: "Tentative {{count}}/5...",
          ipWarning: "Précision réduite (~10km). Vous devrez activer le GPS plus tard."
        },

        banner: {
          title: "Activez votre GPS pour plus de précision",
          description: "Position actuelle basée sur votre IP (~{{distance}}km de précision)",
          activate: "Activer maintenant",
          dismiss: "Plus tard"
        },

        instructions: {
          title: "Comment activer le GPS",
          subtitle: "Suivez ces étapes pour autoriser la localisation",
          yourBrowser: "votre navigateur",
          alternative: "OU",
          retry: "Réessayer maintenant",
          noteTitle: "Note :",
          noteText: "Si le problème persiste, vérifiez que le GPS de votre appareil est bien activé dans les paramètres système.",

          chrome: {
            step1: "Appuyez sur l'icône 🔒 à gauche de l'adresse du site",
            step2: "Sélectionnez 'Paramètres du site' ou 'Autorisations'",
            step3: "Trouvez 'Position' et changez à 'Autoriser'",
            step4: "Rafraîchissez la page"
          },

          safari: {
            step1: "Ouvrez l'app Réglages de votre iPhone/iPad",
            step2: "Faites défiler et sélectionnez 'Safari'",
            step3: "Appuyez sur 'Localisation'",
            step4: "Sélectionnez 'Toujours autoriser' ou 'Autoriser'",
            step5: "Revenez dans l'application"
          },

          generic: {
            step1: "Cliquez sur l'icône de localisation ou de cadenas dans la barre d'adresse",
            step2: "Autorisez l'accès à votre position pour ce site",
            step3: "Assurez-vous que le GPS de votre appareil est activé",
            step4: "Rafraîchissez cette page"
          }
        },

        errors: {
          permissionDenied: "Permission GPS refusée",
          permissionDeniedDescription: "Veuillez autoriser l'accès à votre localisation dans les paramètres de votre navigateur",
          positionUnavailable: "GPS indisponible",
          timeout: "Délai d'attente dépassé",
          generic: "Erreur de géolocalisation",
          updateFailed: "Une erreur est survenue lors de la mise à jour de votre position. Veuillez réessayer."
        },

        required: {
          title: "Localisation requise"
        }
      },
      // Settings
      settings: {
        title: "Paramètres",
        language: "Langue",
        save: "Sauvegarder",
        account: {
          title: "Compte",
          subscription: "Abonnement",
          currentPlan: "Plan actuel",
          subscriptionCode: "Activez un code d'abonnement",
          enterCode: "Entrer le code",
          verifyAccount: "Vérifier le compte",
          verifyCode: "Code de vérification",
          verify: "Vérifier",
          verifying: "Vérification en cours...",
          manageAccount: "Gérer mon compte",
          manageAccountHint: "Les actions sensibles liées au compte se trouvent ici.",
          deleteAccount: "Supprimer le compte",
          deleteConfirm: "Êtes-vous sûr de vouloir supprimer votre compte ?",
          deleteWarning: "Cette action est irréversible",
          deleteGracePeriod: "Votre compte sera immédiatement désactivé. Vous aurez 30 jours pour annuler la demande.",
          deleteDataWarning: "Après ce délai, votre profil, vos photos, vos matchs et vos données d’utilisation seront supprimés définitivement. Certaines données de paiement ou de sécurité peuvent être conservées conformément à la loi.",
          deleteConfirmationPhrase: "SUPPRIMER",
          deleteConfirmationInstruction: "Pour continuer, saisissez exactement {{phrase}} :",
          deleteAcknowledgement: "Je comprends que mon compte sera désactivé immédiatement et que mes données seront supprimées définitivement après 30 jours.",
          confirmDelete: "Programmer la suppression",
          cancel: "Annuler",
          deletionScheduledTitle: "Suppression programmée",
          deletionScheduledMessage: "Votre compte est désactivé. La suppression définitive aura lieu le {{date}}. Reconnectez-vous avant cette date pour annuler.",
          deletionPending: "Suppression du compte programmée",
          deletionPendingUntil: "Votre compte sera supprimé définitivement le {{date}}.",
          cancelDeletion: "Annuler la suppression",
          deletionCancelledTitle: "Suppression annulée",
          deletionCancelledMessage: "Votre compte est de nouveau actif.",
          recentLoginTitle: "Reconnexion nécessaire",
          recentLoginMessage: "Pour protéger votre compte, reconnectez-vous puis recommencez la suppression.",
          reconnect: "Se reconnecter",
          deletionErrorTitle: "Suppression impossible",
          deletionErrorMessage: "Une erreur est survenue. Veuillez réessayer.",
          logout: "Déconnexion",
          phoneNumber: "Numéro de téléphone",
          emailAddress: "Adresse email",
          addPhoneNumber: "Ajouter un numéro",
          addEmail: "Ajouter un email"
        },

        support: {
          title: "Support",
          reportProblem: "Signaler un problème",
          selectProblemType: "Sélectionnez le type de problème",
          describeProblem: "Décrivez le problème en détail...",
          submitting: "Envoi en cours...",
          submit: "Envoyer le rapport",
          problemTypes: {
            bug: "Bug technique",
            feature: "Suggestion d'amélioration",
            other: "Autre"
          }
        },
        discovery: {
          title: "Paramètres de découverte",
          showMe: "Me montrer",
          gender: {
            women: "Femmes",
            men: "Hommes",
            everyone: "Tout le monde"
          },
          distance: {
            title: "Distance maximale"
          },
          age: {
            title: "Tranche d'âge"
          },
          updating: "Mise à jour...",
          applyChanges: "Appliquer les modifications",

        }
      },

      // Home
      home: {
        distance: {
          away: "km away",
          closeBy: "À proximité"
        },
        actions: {
          like: "Like",
          nope: "Nope",
          superLike: "Super Like"
        },
        loading: {
          profiles: "Chargement des profils...",
          sendingMessage: "Envoi du message..."
        },
        subscription: {
          dailyLimitTitle: "Limite quotidienne atteinte ! Passez en premium pour continuer à swiper !",
          upgradeToMessage: "Passez en premium pour envoyer un message !",
          upgradeToGoBack: "Impossible de revenir en arrière ! Passez en premium pour revoir le profil précédent !"
        },
        invitations: {
          noInvitationsLeft: "Plus d'invitations disponibles ! Achetez-en plus ou passez en premium."
        },
        swipe: {
          like: "LIKE",
          nope: "NOPE"
        },
        noProfiles: {
          title: "Plus de profils disponibles",
          description: "Il n'y a plus de profils correspondant à vos critères pour le moment. Modifiez vos critères de recherche ou réessayez plus tard.",
          refresh: "Rafraîchir"
        },
      },

      // Common
      common: {
        loading: "Chargement...",
        error: "Une erreur est survenue",
        retry: "Réessayer",
        save: "Sauvegarder",
        cancel: "Annuler",
        delete: "Supprimer",
        confirm: "Confirmer"
      },
      lookingFor: {
        title: "Objectifs relationnels",
        selectPlaceholder: "Sélectionner votre objectif",
        longTerm: "Relation sérieuse",
        Long: "Relation sérieuse",
        LongOpenShort: "Sérieux, ouvert au court terme",
        longShort: "Sérieux, ouvert au court terme",
        shortLong: "Court terme, ouvert au sérieux",
        shortTerm: "Court terme",
        newFriends: "Nouvelles amitiés"
      },
      interests: {
        sport: "Sport",
        music: "Musique",
        travel: "Voyage",
        reading: "Lecture",
        cinema: "Cinéma",
        art: "Art",
        photography: "Photographie",
        cooking: "Cuisine",
        dance: "Danse",
        gaming: "Gaming",
        fashion: "Mode",
        technology: "Technologie",
        nature: "Nature",
        fitness: "Fitness",
        yoga: "Yoga",
        meditation: "Méditation",
        theater: "Théâtre",
        concert: "Concert",
        festival: "Festival",
        hiking: "Randonnée",
        beach: "Plage",
        shopping: "Shopping",
        volunteering: "Bénévolat",
        languages: "Langues"
      },
      // Profile
      profile: {
        completion: "{{percentage}}% Complet",
        age: ", {{age}}",
        subscription: {
          status: "Trakna {{level}}",
          expiry: "(Expire le {{date}})"
        },
        invitations: "{{count}} Invitations",
        subscriptions: "Abonnements",
        plans: {
          plus: {
            title: "Obtenir Trakna Plus",
            description: "Obtenez des likes illimités, le Passport et plus !",
            cta: "Obtenir Trakna Plus"
          },
          gold: {
            title: "Obtenir Trakna Gold",
            description: "Voyez qui vous aime !",
            cta: "Obtenir Trakna Gold"
          },
          platinum: {
            title: "Obtenir Trakna Platinum",
            description: "Envoyez des messages avant de matcher !",
            cta: "Obtenir Trakna Platinum"
          }
        },
        profileDetail: {
          distance: "{{distance}} km",
          nearbyDistance: "1 km",
          photo: {
            alt: "Photo de {{name}} - {{index}}"
          },
          sections: {
            basicInfo: "Informations de base",
            interests: "Centres d'intérêt",
            languages: "Langues",
            lookingFor: "Je recherche"
          },
          noBio: "Aucune bio disponible",
          languages: {
            french: "Français",
            english: "Anglais",
            spanish: "Espagnol",
            german: "Allemand",
            italian: "Italien",
            portuguese: "Portugais",
            chinese: "Chinois",
            japanese: "Japonais",
            korean: "Coréen",
            arabic: "Arabe",
            russian: "Russe",
            hindi: "Hindi"
          }
        }
      },
      editProfile: {
        title: "Modifier le profil",
        updating: "Mise à jour en cours...",
        bio: {
          title: "Bio",
          placeholder: "Parlez-nous un peu de vous (500 caractères max)",
          maxLengthError: "La bio ne peut pas dépasser 500 caractères"
        },
        lookingFor: {
          title: "Objectifs relationnels",
          selectPlaceholder: "Sélectionner votre objectif"
        },
        interests: {
          title: "Centres d'intérêt",
          selectPlaceholder: "Sélectionner vos centres d'intérêt",
          searchPlaceholder: "Rechercher...",
          moreLabel: "{{first}} +{{remaining}}",

        },
        deletePhoto: {
          confirmTitle: "Supprimer cette photo ?",
          confirmMessage: "Cette photo sera définitivement supprimée de votre profil.",
          confirmButton: "Supprimer",
          cancelButton: "Annuler",
          minimumTitle: "Suppression impossible",
          close: "Fermer"
        },
        errors: {
          uploadFailed: "Échec du téléchargement. Veuillez réessayer.",
          deleteFailed: "Échec de la suppression. Veuillez réessayer.",
          minimumPhotosRequired: "Vous devez avoir au moins 2 photos sur votre profil"
        },
      },
      messages: {
        loadMore: "Voir plus de messages",
        loading: "Chargement des conversations...",
        title: "Messages",
        newMatches: "Nouveaux Matchs",
        searchPlaceholder: "Rechercher...",
        noMessage: "Aucun message",
        noResults: "Aucun contact trouvé pour \"{{query}}\"",
        defaultName: "Utilisateur"
      },
      notifications: {
        loading: "Chargement des notifications...",
        tabs: {
          likes: "Likes ({{count}})",
          invitations: "Invitations ({{count}})"
        },
        empty: {
          likes: "Pas encore de likes",
          invitations: "Pas encore d'invitations"
        },
        premium: {
          required: "Gold ou Platinum requis",
          upgrade: "Passez en premium pour accepter des invitations en illimitées",
          seeLikesTitle: "Découvre qui t'aime & matche instantanamment",
          unlimitedInvitesTitle: "Accepte autant d'invitations que tu veux"
        },
        invitations: {
          remaining: "Invitations restantes cette semaine : {{remaining}}/2",
          timeRemaining: "Temps restant avant de pouvoir accepter une autre invitation : {{days}} jours, {{hours}} heures et {{minutes}} minutes",
          standard: "Standard"
        },
        actions: {
          accept: "Accepter",
          decline: "Refuser"
        },
        errors: {
          weeklyLimitReached: "Vous avez atteint votre limite de 2 invitations par semaine. Passez en premium pour en accepter plus !",
          general: "Une erreur est survenue. Veuillez réessayer.",
          loadMore: "Erreur lors du chargement des invitations supplémentaires"
        }
      },
      invite: {
        title: "Inviter {{name}}",
        subtitle: "Choisissez une invitation",
        types: {
          restaurant: "Restaurant",
          lounge: "Lounge-Bar",
          maquis: "Maquis",
          gaming: "Gaming",
          cinema: "Cinéma",
          beach: "Plage"
        },
        loading: "Envoi de l'invitation en cours...",
        send: "Envoyer l'invitation"
      },
      login: {
        title: "Entrez votre numéro de téléphone",
        subtitle: "Nous vous enverrons un code pour vérifier votre numéro",
        continue: "Continuer",
        sending: "Envoi en cours...",
        errors: {
          recaptchaInit: "Échec de l'initialisation du système de vérification",
          invalidPhone: "Veuillez entrer un numéro de téléphone valide",
          verificationFailed: "Échec de l'envoi du code de vérification. Veuillez réessayer.",
          tooManyRequests: "Trop de tentatives de connexion. Veuillez réessayer plus tard",
          phoneRequired: "Le numéro de téléphone est requis",
          general: "Une erreur est survenue, veuillez réessayer",
          regionNotAllowed: "Désolé, l'envoi de SMS vers cette région n'est pas autorisé. Veuillez contacter le support."
        },
        phoneLabels: {
          country: "Pays",
          phone: "Numéro de téléphone",
          AB: "Abkhazia",
          AC: "Île de l'Ascension",
          AD: "Andorre",
          AE: "Émirats arabes unis",
          AF: "Afghanistan",
          AG: "Antigua-et-Barbuda",
          AI: "Anguilla",
          AL: "Albanie",
          AM: "Arménie",
          AO: "Angola",
          AR: "Argentine",
          AS: "Samoa américaines",
          AT: "Autriche",
          AU: "Australie",
          AW: "Aruba",
          AX: "Îles Åland",
          AZ: "Azerbaïdjan",
          BA: "Bosnie-Herzégovine",
          BB: "Barbade",
          BD: "Bangladesh",
          BE: "Belgique",
          BF: "Burkina Faso",
          BG: "Bulgarie",
          BH: "Bahreïn",
          BI: "Burundi",
          BJ: "Bénin",
          BL: "Saint-Barthélemy",
          BM: "Bermudes",
          BN: "Brunei",
          BO: "Bolivie",
          BQ: "Pays-Bas caribéens",
          BR: "Brésil",
          BS: "Bahamas",
          BT: "Bhoutan",
          BW: "Botswana",
          BY: "Biélorussie",
          BZ: "Belize",
          CA: "Canada",
          CC: "Îles Cocos",
          CD: "Congo-Kinshasa",
          CF: "République centrafricaine",
          CG: "Congo-Brazzaville",
          CH: "Suisse",
          CI: "Côte d'Ivoire",
          CK: "Îles Cook",
          CL: "Chili",
          CM: "Cameroun",
          CN: "Chine",
          CO: "Colombie",
          CR: "Costa Rica",
          CU: "Cuba",
          CV: "Cap-Vert",
          CW: "Curaçao",
          CX: "Île Christmas",
          CY: "Chypre",
          CZ: "République tchèque",
          DE: "Allemagne",
          DJ: "Djibouti",
          DK: "Danemark",
          DM: "Dominique",
          DO: "République dominicaine",
          DZ: "Algérie",
          EC: "Équateur",
          EE: "Estonie",
          EG: "Égypte",
          EH: "Sahara occidental",
          ER: "Érythrée",
          ES: "Espagne",
          ET: "Éthiopie",
          FI: "Finlande",
          FJ: "Fidji",
          FK: "Îles Malouines",
          FM: "Micronésie",
          FO: "Îles Féroé",
          FR: "France",
          GA: "Gabon",
          GB: "Royaume-Uni",
          GD: "Grenade",
          GE: "Géorgie",
          GF: "Guyane française",
          GG: "Guernesey",
          GH: "Ghana",
          GI: "Gibraltar",
          GL: "Groenland",
          GM: "Gambie",
          GN: "Guinée",
          GP: "Guadeloupe",
          GQ: "Guinée équatoriale",
          GR: "Grèce",
          GT: "Guatemala",
          GU: "Guam",
          GW: "Guinée-Bissau",
          GY: "Guyana",
          HK: "Hong Kong",
          HN: "Honduras",
          HR: "Croatie",
          HT: "Haïti",
          HU: "Hongrie",
          ID: "Indonésie",
          IE: "Irlande",
          IL: "Israël",
          IM: "Île de Man",
          IN: "Inde",
          IO: "Territoire britannique de l'océan Indien",
          IQ: "Irak",
          IR: "Iran",
          IS: "Islande",
          IT: "Italie",
          JE: "Jersey",
          JM: "Jamaïque",
          JO: "Jordanie",
          JP: "Japon",
          KE: "Kenya",
          KG: "Kirghizistan",
          KH: "Cambodge",
          KI: "Kiribati",
          KM: "Comores",
          KN: "Saint-Kitts-et-Nevis",
          KP: "Corée du Nord",
          KR: "Corée du Sud",
          KW: "Koweït",
          KY: "Îles Caïmans",
          KZ: "Kazakhstan",
          LA: "Laos",
          LB: "Liban",
          LC: "Sainte-Lucie",
          LI: "Liechtenstein",
          LK: "Sri Lanka",
          LR: "Libéria",
          LS: "Lesotho",
          LT: "Lituanie",
          LU: "Luxembourg",
          LV: "Lettonie",
          LY: "Libye",
          MA: "Maroc",
          MC: "Monaco",
          MD: "Moldavie",
          ME: "Monténégro",
          MF: "Saint-Martin",
          MG: "Madagascar",
          MH: "Îles Marshall",
          MK: "Macédoine du Nord",
          ML: "Mali",
          MM: "Myanmar",
          MN: "Mongolie",
          MO: "Macao",
          MP: "Îles Mariannes du Nord",
          MQ: "Martinique",
          MR: "Mauritanie",
          MS: "Montserrat",
          MT: "Malte",
          MU: "Maurice",
          MV: "Maldives",
          MW: "Malawi",
          MX: "Mexique",
          MY: "Malaisie",
          MZ: "Mozambique",
          NA: "Namibie",
          NC: "Nouvelle-Calédonie",
          NE: "Niger",
          NF: "Île Norfolk",
          NG: "Nigeria",
          NI: "Nicaragua",
          NL: "Pays-Bas",
          NO: "Norvège",
          NP: "Népal",
          NR: "Nauru",
          NU: "Niue",
          NZ: "Nouvelle-Zélande",
          OM: "Oman",
          PA: "Panama",
          PE: "Pérou",
          PF: "Polynésie française",
          PG: "Papouasie-Nouvelle-Guinée",
          PH: "Philippines",
          PK: "Pakistan",
          PL: "Pologne",
          PM: "Saint-Pierre-et-Miquelon",
          PN: "Îles Pitcairn",
          PR: "Porto Rico",
          PS: "Palestine",
          PT: "Portugal",
          PW: "Palaos",
          PY: "Paraguay",
          QA: "Qatar",
          RE: "La Réunion",
          RO: "Roumanie",
          RS: "Serbie",
          RU: "Russie",
          RW: "Rwanda",
          SA: "Arabie saoudite",
          SB: "Îles Salomon",
          SC: "Seychelles",
          SD: "Soudan",
          SE: "Suède",
          SG: "Singapour",
          SH: "Sainte-Hélène",
          SI: "Slovénie",
          SJ: "Svalbard et Jan Mayen",
          SK: "Slovaquie",
          SL: "Sierra Leone",
          SM: "Saint-Marin",
          SN: "Sénégal",
          SO: "Somalie",
          SR: "Suriname",
          SS: "Soudan du Sud",
          ST: "Sao Tomé-et-Principe",
          SV: "Salvador",
          SX: "Saint-Martin (partie néerlandaise)",
          SY: "Syrie",
          SZ: "Eswatini",
          TC: "Îles Turques-et-Caïques",
          TD: "Tchad",
          TF: "Terres australes françaises",
          TG: "Togo",
          TH: "Thaïlande",
          TJ: "Tadjikistan",
          TK: "Tokelau",
          TL: "Timor oriental",
          TM: "Turkménistan",
          TN: "Tunisie",
          TO: "Tonga",
          TR: "Turquie",
          TT: "Trinité-et-Tobago",
          TV: "Tuvalu",
          TW: "Taïwan",
          TZ: "Tanzanie",
          UA: "Ukraine",
          UG: "Ouganda",
          US: "États-Unis",
          UY: "Uruguay",
          UZ: "Ouzbékistan",
          VA: "Vatican",
          VC: "Saint-Vincent-et-les-Grenadines",
          VE: "Venezuela",
          VG: "Îles Vierges britanniques",
          VI: "Îles Vierges américaines",
          VN: "Vietnam",
          VU: "Vanuatu",
          WF: "Wallis-et-Futuna",
          WS: "Samoa",
          XK: "Kosovo",
          YE: "Yémen",
          YT: "Mayotte",
          ZA: "Afrique du Sud",
          ZM: "Zambie",
          ZW: "Zimbabwe"
        }
      },
      terms: {
        title: "Conditions d'utilisation",
        sections: {
          acceptance: {
            title: "Acceptation des conditions",
            content: "En utilisant l'application Trakna, vous acceptez d'être lié par ces conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser l'application."
          },
          eligibility: {
            title: "Éligibilité",
            content: "L'utilisation de Trakna est strictement réservée aux personnes âgées de 18 ans ou plus. En créant un compte, vous certifiez avoir au moins 18 ans et être légalement capable de conclure un contrat contraignant."
          },
          userAccount: {
            title: "Compte utilisateur",
            content: "Vous êtes responsable de maintenir la confidentialité de vos informations de compte. Vous devez fournir des informations exactes lors de votre inscription, notamment votre nom, email, âge et localisation."
          },
          userConduct: {
            title: "Comportement de l'utilisateur",
            content: "Vous acceptez de ne pas : harceler d'autres utilisateurs, publier du contenu inapproprié, usurper l'identité d'autres personnes, ou utiliser l'application à des fins illégales."
          },
          subscriptions: {
            title: "Abonnements",
            content: "Trakna propose trois niveaux d'abonnement premium : Plus, Gold et Platinum. Chaque niveau offre des fonctionnalités supplémentaires. Les prix et conditions sont indiqués dans l'application."
          },
          features: {
            title: "Fonctionnalités",
            content: "L'application propose des fonctionnalités de swipe, match, messagerie et invitations. Ces fonctionnalités doivent être utilisées dans le respect des autres utilisateurs."
          },
          termination: {
            title: "Résiliation",
            content: "Nous nous réservons le droit de suspendre ou résilier votre compte en cas de violation de ces conditions ou de comportement inapproprié."
          },
          disclaimer: {
            title: "Limitation de responsabilité",
            content: "L'application Trakna est fournie 'en l'état'. Nous ne garantissons pas que l'application sera exempte d'erreurs ou disponible de manière ininterrompue. Nous ne sommes pas responsables des dommages directs ou indirects résultant de l'utilisation de l'application."
          },
          contact: {
            title: "Contact",
            content: "Pour toute question concernant ces conditions d'utilisation, contactez-nous via l'application."
          }
        }
      },

      privacy: {
        title: "Politique de confidentialité",
        sections: {
          dataCollection: {
            title: "Collecte des données",
            content: "Nous collectons les informations suivantes : nom, adresse email, localisation géographique et âge. Ces données sont nécessaires pour le fonctionnement du service et la sécurité des utilisateurs."
          },
          dataUse: {
            title: "Utilisation des données",
            content: "Vos données sont utilisées pour : créer et gérer votre compte, vous connecter avec d'autres utilisateurs à proximité, vérifier votre âge, et améliorer nos services."
          },
          location: {
            title: "Données de localisation",
            content: "Nous utilisons votre localisation pour vous mettre en relation avec des utilisateurs proches de vous. Vous pouvez gérer les permissions de localisation dans les paramètres de votre appareil."
          },
          dataSecurity: {
            title: "Sécurité des données",
            content: "Nous utilisons des mesures de sécurité appropriées pour protéger vos données personnelles contre tout accès non autorisé ou utilisation abusive."
          },
          dataSharing: {
            title: "Partage des données",
            content: "Nous ne partageons pas vos informations personnelles avec des tiers, sauf si la loi l'exige ou avec votre consentement explicite."
          },
          cookies: {
            title: "Cookies et technologies similaires",
            content: "Nous utilisons des cookies et technologies similaires pour améliorer votre expérience, analyser l'utilisation de nos services et personnaliser le contenu. Vous pouvez contrôler l'utilisation des cookies dans les paramètres de votre navigateur."
          },
          dataRetention: {
            title: "Conservation des données",
            content: "Nous conservons vos données personnelles aussi longtemps que votre compte est actif ou nécessaire pour vous fournir nos services. Vous pouvez demander la suppression de vos données à tout moment via les paramètres de l'application."
          },
          userRights: {
            title: "Vos droits",
            content: "Vous avez le droit d'accéder à vos données, de les modifier ou de les supprimer. Vous pouvez également demander une copie de vos données."
          },
          contact: {
            title: "Contact",
            content: "Pour toute question concernant vos données personnelles, contactez-nous via l'application."
          }
        }
      },
      pwa: {
        title: "Installer Trakna",
        message: "Installez Trakna sur votre écran d'accueil pour un accès rapide et une meilleure expérience",
        messageIOS: "Pour installer l'application : appuyez sur l'icône de partage puis 'Sur l'écran d'accueil'",
        install: "Installer",
        got_it: "J'ai compris",
        notNow: "Plus tard"
      },
      otp: {
        title: "Entrez votre code",
        resend: "Renvoyer",
        verify: "Vérifier",
        verifying: "Vérification...",
        digitLabel: "Chiffre {{number}} du code",
        errors: {
          enterAllDigits: "Veuillez entrer tous les chiffres",
          invalidCode: "Code de vérification invalide. Veuillez réessayer.",
          resendFailed: "Échec de l'envoi du code. Veuillez réessayer."
        }
      },
      welcomePolicy: {
        title: "Bienvenue sur Trakna",
        subtitle: "Veuillez suivre ces règles de la maison",
        agree: "J'accepte",
        rules: {
          beYourself: {
            title: "Soyez vous-même",
            description: "Assurez-vous que vos photos, votre âge et votre bio reflètent qui vous êtes vraiment"
          },
          staySafe: {
            title: "Restez prudent",
            description: "N'acceptez des rendez-vous que dans des lieux publics"
          },
          playItCool: {
            title: "Restez cool",
            description: "Respectez les autres et traitez-les comme vous aimeriez être traité"
          },
          beProactive: {
            title: "Soyez proactif",
            description: "Ne donnez pas trop rapidement vos informations personnelles"
          },
          goldenRule: {
            title: "Règle d'or",
            description: "Trakez-vous !"
          }
        }
      },
      firstName: {
        title: "Votre Nom ",
        namePlaceholder: "Entrez votre nom",
        nameAriaLabel: "Champ de saisie du nom",
        birthdayTitle: "Quelle est votre date de naissance ?",
        birthdayPlaceholder: "Sélectionnez votre date de naissance",
        next: "Suivant",
        errors: {
          nameLength: "Le prénom doit contenir au moins 4 caractères",
          ageLimit: "Vous devez avoir au moins 18 ans"
        }
      },
      yourGender: {
        title: "Vous êtes ?",
        options: {
          women: "Femme",
          men: "Homme"
        },
        ariaLabel: "Sélectionner le genre {{gender}}",
        next: "Suivant"
      },
      interested: {
        title: "Qui souhaitez-vous rencontrer ?",
        options: {
          women: "Femmes",
          men: "Hommes",
          everyone: "Tout le monde"
        },
        ariaLabel: "Sélectionner {{interest}} comme préférence",
        next: "Suivant"
      },
      recentPics: {
        title: "Ajoutez vos photos récentes",
        subtitle: "Téléchargez 2 photos pour commencer. Ajoutez-en 4 ou plus pour faire ressortir votre profil.",
        imageAlt: "Photo téléchargée {{number}}",
        defaultImageAlt: "Image par défaut",
        addPhotoAriaLabel: "Ajouter une photo",
        removePhotoAriaLabel: "Supprimer la photo",
        uploadInputAriaLabel: "Télécharger la photo {{number}}",
        uploading: "Téléchargement en cours...",
        continue: "Continuer",
        errors: {
          uploadFailed: "Échec du téléchargement de l'image",
          minimumPhotos: "Veuillez télécharger au moins 2 photos",
          updateFailed: "Erreur lors de la mise à jour du profil. Veuillez réessayer."
        }
      },
      match: {
        congrats: "Félicitations !",
        itsAMatch: "C'est un match !",
        sendMessage: "Envoyer un message",
        continue: "Continuer à swiper",
        yourProfile: "Votre profil",
        matchProfile: "Profil du match"
      },
      chat: {
        blockUserConfirm: {
          title: "Bloquer l'utilisateur",
          content: "Voulez-vous vraiment bloquer {{name}} ? Vous ne pourrez plus échanger de messages avec cette personne.",
          okText: "Bloquer",
          cancelText: "Annuler"
        },
        unblockUserConfirm: {
          title: "Débloquer l'utilisateur",
          content: "Voulez-vous débloquer {{name}} ? Vous pourrez à nouveau échanger des messages.",
          okText: "Débloquer",
          cancelText: "Annuler"
        },
        blockUserSuccess: "{{name}} a été bloqué(e)",
        blockUserError: "Une erreur est survenue lors du blocage",
        unblockUserSuccess: "{{name}} a été débloqué(e)",
        unblockUserError: "Une erreur est survenue lors du déblocage",
        blockedInputPlaceholder: "Vous ne pouvez plus échanger de messages avec cette personne",
        inputPlaceholder: "Écrivez votre message...",
        block: "Bloquer",
        unblock: "Débloquer",
        typeMessage: "Écrivez votre message...",
        send: "Envoyer",
        loading: "Chargement des messages...",
        loadMore: "Voir plus"
      }
    }
  },
  en: {
    translation: {
      settings: {
        account: {
          manageAccount: "Manage my account",
          manageAccountHint: "Sensitive account actions are available here.",
          deleteAccount: "Delete account",
          deleteConfirm: "Are you sure you want to delete your account?",
          deleteGracePeriod: "Your account will be disabled immediately. You will have 30 days to cancel the request.",
          deleteDataWarning: "After that period, your profile, photos, matches and usage data will be permanently deleted. Some payment or safety records may be retained as required by law.",
          deleteConfirmationPhrase: "DELETE",
          deleteConfirmationInstruction: "To continue, type {{phrase}} exactly:",
          deleteAcknowledgement: "I understand that my account will be disabled immediately and that my data will be permanently deleted after 30 days.",
          confirmDelete: "Schedule deletion",
          cancel: "Cancel",
          deletionScheduledTitle: "Deletion scheduled",
          deletionScheduledMessage: "Your account is disabled. It will be permanently deleted on {{date}}. Sign in before that date to cancel.",
          deletionPending: "Account deletion scheduled",
          deletionPendingUntil: "Your account will be permanently deleted on {{date}}.",
          cancelDeletion: "Cancel deletion",
          deletionCancelledTitle: "Deletion cancelled",
          deletionCancelledMessage: "Your account is active again.",
          recentLoginTitle: "Sign-in required",
          recentLoginMessage: "To protect your account, sign in again and restart the deletion request.",
          reconnect: "Sign in again",
          deletionErrorTitle: "Unable to delete account",
          deletionErrorMessage: "An error occurred. Please try again."
        }
      },
      // Auth & Welcome
      welcome: {
        title: "Welcome to Trakna",
        subtitle: "Meet people who share your interests",
        logoAlt: "Trakna Logo",
        continueWithGoogle: "Continue with Google",
        continueWithFacebook: "Continue with Facebook",
        continueWithPhone: "Continue with phone",
        googleAlt: "Google Logo",
        facebookAlt: "Facebook Logo",
        termsText: "By logging in, you agree to our",
        termsLink: "Terms of Use",
        and: "and our",
        privacyLink: "Privacy Policy",
        errors: {
          default: "An error occurred during login",
          popupClosed: "Login window was closed",
          requestCancelled: "Login request was cancelled",
          accountExists: "An account already exists with another login method",
          network: "Network connection error. Please check your internet connection",
          tooManyRequests: "Too many login attempts. Please try again later",
          phoneRequired: "Le numéro de téléphone est requis",
          invalidPhone: "Le numéro de téléphone n'est pas valide",
          recaptchaInit: "Erreur d'initialisation de reCAPTCHA",
          general: "Une erreur est survenue, veuillez réessayer",
          regionNotAllowed: "Désolé, l'envoi de SMS vers cette région n'est pas autorisé. Veuillez contacter le support."
        },
        login: {
          google: "Continue with Google",
          facebook: "Continue with Facebook"
        },
        legal: {
          agreement: "By continuing, you agree to our",
          terms: "Terms of Use",
          and: "and our",
          privacy: "Privacy Policy"
        }
      },

      // Subscription
      subscription: {
        mySubscription: "My Subscription",
        startingFrom: "Starting from",
        plans: {
          plus: {
            title: "Trakna Plus",
            name: "PLUS",
            description: "Swipe without limits!",
            features: {
              unlimitedLikes: "Unlimited likes",
              seeWhoLikesYou: "See who likes you",
              priorityLikes: "Priority likes",
              unlimitedRewinds: "Unlimited rewinds",
              freeInvitations: "Free invitations per week",
              acceptInvitations: "Accept unlimited invitations",
              messageBeforeMatch: "Message before match",
              passport: "Passport",
              topPicks: "Boosted profile"
            }
          },
          gold: {
            title: "Trakna Gold",
            name: "GOLD",
            description: "Discover who liked your profile to match instantly!",
            features: {
              unlimitedLikes: "Unlimited likes",
              seeWhoLikesYou: "See who likes you",
              priorityLikes: "Priority likes",
              unlimitedRewinds: "Unlimited rewinds",
              freeInvitations: "2 Free invitations per week",
              acceptInvitations: "Accept unlimited invitations",
              messageBeforeMatch: "Message before match",
              passport: "Passport",
              topPicks: "Boosted profile"
            }
          },
          platinum: {
            title: "Trakna Platinum",
            name: "PLATINUM",
            description: "Enjoy all our premium features!",
            features: {
              unlimitedLikes: "Unlimited likes",
              seeWhoLikesYou: "See who likes you",
              priorityLikes: "Priority likes",
              unlimitedRewinds: "Unlimited rewinds",
              freeInvitations: "5 Free invitations per week",
              acceptInvitations: "Accept unlimited invitations",
              messageBeforeMatch: "Message before match",
              passport: "Passport",
              topPicks: "Boosted profile"
            }
          }
        },
        duration: {
          oneMonth: "1 month",
          threeMonths: "3 months",
          sixMonths: "6 months"
        },
        continue: "Continue",
        perMonth: "per month",
        discount: "- {{percent}}%",
        upgradeMessages: {
          swipeLimit: "Daily swipe limit reached! Upgrade to premium to continue!",
          message: "Upgrade to premium to send a message!",
          goBack: "Can't go back! Upgrade to premium to see the previous profile!",
          invitations: "Upgrade to premium to accept unlimited invitations!"
        },
        features: {
          unlimitedLikes: "Unlimited likes",
          seeWhoLikedYou: "Discover who liked your profile",
          unlimitedRewinds: "Unlimited rewinds",
          freeBoostMonthly: "1 Free boost per month",
          freeSuperlikes: "2 Free superlikes per week",
          passportMode: "Unlimited Passport mode",
          description: "Match and chat with people worldwide.",
          topPicks: "Top Picks",
          description2: "Discover a selection of profiles daily.",
          profileControl: "Control your profile from A to Z",
          description3: "Only show what you want to show."
        }
      },
      paymentPhone: {
        title: "Payment phone number",
        description: "This number will be used to open the payment page.",
        invalid: "Invalid phone number. Check the number and country code.",
        cancel: "Cancel",
        continue: "Continue",
        processing: "Opening..."
      },
      location: {
        title: "Enable Location",
        subtitle: "To suggest the best profiles near you, we need your location.",
        enableLocation: "Enable Location",
        locating: "Locating...",
        errors: {
          geolocationFailed: "An error occurred during geolocation. Please check your location settings.",
          updateFailed: "An error occurred while updating your position. Please try again."
        }
      },
      profile: {
        completion: "{{percentage}}% Complete",
        age: ", {{age}}",
        subscription: {
          status: "Trakna {{level}}"
        }
      },
      chat: {
        blockUserConfirm: {
          title: "Block User",
          content: "Do you want to block {{name}}? You won't be able to exchange messages with this person.",
          okText: "Block",
          cancelText: "Cancel"
        },
        unblockUserConfirm: {
          title: "Unblock User",
          content: "Do you want to unblock {{name}}? You'll be able to exchange messages again.",
          okText: "Unblock",
          cancelText: "Cancel"
        },
        blockUserSuccess: "{{name}} has been blocked",
        blockUserError: "An error occurred while blocking",
        unblockUserSuccess: "{{name}} has been unblocked",
        unblockUserError: "An error occurred while unblocking",
        blockedInputPlaceholder: "You can no longer exchange messages with this person",
        inputPlaceholder: "Type your message...",
        block: "Block",
        unblock: "Unblock",
        send: "Send",
        loading: "Loading messages...",
        loadMore: "Load more"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
